module.exports = __webpack_public_path__ + "static/media/fly0240.1877d631.webp";